module.exports = __webpack_public_path__ + "media/images/hotline-phone-ab1abc353a63a5182026a9dc03e04d71.png";